export default [
  {
    id: 1,
    arImg: "../images/coffee.png",
    arHeader: "Reasons why children should avoid cofee",
    arDesc:
      "12 rules of a balanced health 12 rules of a balanced health 12 rules of a balanced health ",
  },
  {
    id: 2,
    arImg: "../images/salad.png",
    arHeader: "12 rules of a balanced health ",
    arDesc:
      "12 rules of a balanced health 12 rules of a balanced health 12 rules of a balanced health ",
  },
  {
    id: 3,
    arImg: "../images/fitness.png",
    arHeader: "5 reasons why you should exercise daily",
    arDesc:
      "12 rules of a balanced health 12 rules of a balanced health 12 rules of a balanced health ",
  },
];
